import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from "react-dom";
import { App } from "./components";
import { registerServiceWorker } from "./stores";
ReactDOM.render(_jsx(App, {}, void 0), document.querySelector("#app"));
registerServiceWorker();
